module.exports = __webpack_public_path__ + "static/media/doubleLeftGif.a3fbba75.gif";